import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';

// Type-to-filter combobox: a text input that shows matching options in a
// dropdown below as you type. Clicking a match calls onSelect(option); the
// field then displays getLabel(option). Replaces native <select> dropdowns
// wherever the list is long enough that scanning options isn't as fast as
// typing a few letters (Cliente, Producto).
const SearchSelect = ({
  options,
  value,
  getLabel,
  getKey,
  onSelect,
  placeholder = 'Escribe para buscar...',
  emptyLabel = 'Sin resultados',
}) => {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selected = options.find(o => getKey(o) === value);
  const selectedLabel = selected ? getLabel(selected) : '';

  // Show the chosen option's label — also when the options arrive AFTER the value (a saved factura loads faster than
  // the ~5,000 clients, which left the Cliente box empty on a factura made from a rental).
  useEffect(() => {
    setQuery(selectedLabel);
  }, [value, selectedLabel]);

  // Strip accents so "oxi" matches "Oxígeno" — Spanish input is rarely typed
  // with diacritics, especially on mobile.
  const normalize = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

  const matches = query.trim()
    ? options.filter(o => normalize(getLabel(o)).includes(normalize(query.trim())))
    : options;

  const handleSelect = (option) => {
    onSelect(option);
    setQuery(getLabel(option));
    setOpen(false);
  };

  return (
    <div className="search-select" ref={containerRef}>
      <Form.Control
        value={query}
        placeholder={placeholder}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && (
        <div className="search-select-menu">
          {matches.length === 0 && <div className="search-select-empty">{emptyLabel}</div>}
          {matches.map(option => (
            <div
              key={getKey(option)}
              className="search-select-item"
              onMouseDown={() => handleSelect(option)}
            >
              {getLabel(option)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchSelect;
